import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const RESOURCE_S3_RESOURCE_CODE: {
  RESOURCE_S3_RESOURCE_COPIED_LIVE_BUCKET_ALREADY: MvnCodeBE;
  RESOURCE_S3_RESOURCE_FORMAT_NOT_ALLOWED: MvnCodeBE;
} = {
  RESOURCE_S3_RESOURCE_COPIED_LIVE_BUCKET_ALREADY: {
    status: 409,
    ko: "요청하신 Resource는 이미 Live Bucket으로 복사가 완료되었습니다.",
    en: "The requested resource has already been copied to live bucket.",
  },
  RESOURCE_S3_RESOURCE_FORMAT_NOT_ALLOWED: {
    status: 400,
    ko: "선택한 파일은 업로드를 지원하지 않는 형식입니다.",
    en: "The file format is not supported.",
  },
};

MvnCodeInitiate(RESOURCE_S3_RESOURCE_CODE);
